import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Dotpoints02 = function Dotpoints02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M21 5H10m11 14H10m11-7H10M6 5c0 .8284-.6716 1.5-1.5 1.5S3 5.8284 3 5s.6716-1.5 1.5-1.5S6 4.1716 6 5m0 14c0 .8284-.6716 1.5-1.5 1.5S3 19.8284 3 19s.6716-1.5 1.5-1.5S6 18.1716 6 19m0-7c0 .8284-.6716 1.5-1.5 1.5S3 12.8284 3 12s.6716-1.5 1.5-1.5S6 11.1716 6 12"
    })
  }));
};
export default Dotpoints02;